import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughIVRMenuProps = {
  node: ConversationFlowAuditLogEntry<'IVR_MENU_NODE_VISITED'>;
};

export function RoutedThroughIVRMenu({
  node,
}: RoutedThroughIVRMenuProps): JSX.Element {
  return (
    <>
      IVR ·{' '}
      {node.input ? (
        <>
          Pressed <strong>{node.input}</strong>
        </>
      ) : (
        'No response'
      )}
    </>
  );
}
